import PropTypes from 'prop-types';
import styled from '@emotion/styled';

const Path = styled.path`
  fill: var(--color-base-1);
`;

const MwebWinnerCardBgIcon = (props) => {
  const { width, height } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 140 116"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path d="M100.33 29.5C100.33 32.0358 100.004 34.4969 99.3922 36.8451C98.6339 39.7552 100.617 43 103.625 43L132 43C136.418 43 140 46.5817 140 51V108C140 112.418 136.418 116 132 116H8C3.58172 116 0 112.418 0 108V51C0 46.5817 3.58172 43 8 43L37.0344 43C40.0417 43 42.0253 39.7552 41.2669 36.8451C40.655 34.4969 40.3296 32.0358 40.3296 29.5C40.3296 13.2076 53.761 0 70.3296 0C86.8981 0 100.33 13.2076 100.33 29.5Z" />
    </svg>
  );
};

MwebWinnerCardBgIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number
};

MwebWinnerCardBgIcon.defaultProps = {
  width: 14,
  height: 24
};

export default MwebWinnerCardBgIcon;
